import { useCallback, useEffect, useRef, useState } from "react";
import { API } from "../../data/siteData";
import { csrfHeaders } from "../../utils/csrf";

export default function useSessionIdentity(onSessionEnded) {
  const [user, setUser] = useState(null);
  const [showWarning, setShowWarning] = useState(false);
  const onSessionEndedRef = useRef(onSessionEnded);
  const userRef = useRef(user);

  useEffect(() => {
    onSessionEndedRef.current = onSessionEnded;
  }, [onSessionEnded]);

  const setActiveUser = useCallback((nextUser) => {
    userRef.current = nextUser;
    setUser(nextUser);
  }, []);

  const endSession = useCallback(async () => {
    const role = userRef.current?.role;
    await fetch(`${API}/auth/logout`, {
      method: "POST",
      credentials: "include",
      headers: csrfHeaders(),
    });
    setActiveUser(null);
    setShowWarning(false);
    window.dispatchEvent(new Event("gameday-session-ended"));
    onSessionEndedRef.current(role);
  }, [setActiveUser]);

  return {
    endSession,
    setActiveUser,
    setShowWarning,
    showWarning,
    user,
    userRef,
  };
}